import { jsx as _jsx } from "react/jsx-runtime";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import { AnimatePresence, motion } from "framer-motion";
import { GNBSubNav } from "./GNBSubNav";
const GNBSubNavContainer = (param)=>{
    let { gnbMenuData , selectedHomeId , onHomeChange , onCategoryHover , isCategoryMenuOpen  } = param;
    const isVisible = useScrollVisibility({
        mode: "direction",
        topThreshold: 10
    });
    var _gnbMenuData_homeNavigation, _gnbMenuData_tabs;
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        initial: false,
        children: isVisible && /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                height: 0,
                opacity: 0,
                overflow: "hidden"
            },
            animate: {
                height: "auto",
                opacity: 1,
                overflow: "visible"
            },
            exit: {
                height: 0,
                opacity: 0,
                overflow: "hidden"
            },
            transition: {
                duration: 0.2,
                ease: "easeOut"
            },
            children: /*#__PURE__*/ _jsx(GNBSubNav, {
                selectedHomeId: selectedHomeId,
                onHomeChange: onHomeChange,
                homeNavigation: (_gnbMenuData_homeNavigation = gnbMenuData === null || gnbMenuData === void 0 ? void 0 : gnbMenuData.homeNavigation) !== null && _gnbMenuData_homeNavigation !== void 0 ? _gnbMenuData_homeNavigation : [],
                marketingTabs: (_gnbMenuData_tabs = gnbMenuData === null || gnbMenuData === void 0 ? void 0 : gnbMenuData.tabs) !== null && _gnbMenuData_tabs !== void 0 ? _gnbMenuData_tabs : [],
                onCategoryHover: onCategoryHover,
                isCategoryMenuOpen: isCategoryMenuOpen
            })
        })
    });
};
export default GNBSubNavContainer;
